import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonAlpha, StackBlock, TextAlpha } from '@yonderland/andes-react';
import { PickupPointSearchForm } from './PickupPointSearchForm';
import { useTranslation } from 'react-i18next';
import { HTTPStatusCode } from '@as-react/common-types';
import { PickupPoint } from './PickupPoint';
import { useDeliveryState, usePickupPointSearchContext } from '../../../../context/CheckoutDeliveryContext';
import { StoreListLoader } from '../../../product-detail/store-finder-popup/store-list-loader/StoreListLoader';
import { useMutation } from '@tanstack/react-query';
import { checkoutMutations } from '@as-react/common-queries';
import { useAemConfig } from '@as-react/common-components';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { DeliverySheet } from '../DeliverySheet';
const PickupPoints = () => {
    const [{ pickupPoint }] = useDeliveryState();
    const { highlightedPickupPoint, selectedPickupPoint } = pickupPoint;
    const { getPickupPointsQuery, locationSearch } = usePickupPointSearchContext();
    const { data: pickupPointsResponse, isLoading } = getPickupPointsQuery;
    if (isLoading) {
        return _jsx(StoreListLoader, {});
    }
    if (!pickupPointsResponse || !locationSearch || pickupPointsResponse.status === HTTPStatusCode.NoContent)
        return null;
    return (_jsx(StackBlock, { gap: "4", children: pickupPointsResponse.data.map(pickupPoint => (_jsx(PickupPoint, { pickupPoint: pickupPoint, selected: (highlightedPickupPoint === null || highlightedPickupPoint === void 0 ? void 0 : highlightedPickupPoint.id) === pickupPoint.id ||
                (!highlightedPickupPoint && (selectedPickupPoint === null || selectedPickupPoint === void 0 ? void 0 : selectedPickupPoint.id) === pickupPoint.id) }, pickupPoint.id))) }));
};
export const PickupPointSelector = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [{ pickupPoint, activeDeliveryOption, deliveryCountryId, openSelector }, dispatch] = useDeliveryState();
    const { highlightedPickupPoint, selectedPickupPoint } = pickupPoint;
    const isOpen = openSelector === 'pickup-point';
    const { postPickupPoint } = checkoutMutations({ servicesEndpoint, defaultRequestParams });
    const postPickupPointMutation = useMutation(postPickupPoint);
    const selectPickupPoint = () => {
        if (!highlightedPickupPoint)
            return;
        postPickupPointMutation.mutate({
            countryCode: String(deliveryCountryId),
            provider: activeDeliveryOption.provider,
            pickupPoint: highlightedPickupPoint,
        }, {
            onSuccess: data => {
                dispatch({ type: 'select_pickup_point', payload: highlightedPickupPoint });
                dispatch({ type: 'set_location_information', payload: data.data });
                dispatch({ type: 'highlight_pickup_point', payload: null });
            },
            onError: () => {
                dispatch({ type: 'set_active_delivery_option', payload: undefined });
            },
            onSettled: () => {
                dispatch({ type: 'set_open_selector', payload: undefined });
            },
        });
    };
    const resetDeliveryOption = () => {
        dispatch({ type: 'highlight_pickup_point', payload: null });
        dispatch({ type: 'set_open_selector', payload: undefined });
        if (!selectedPickupPoint) {
            dispatch({ type: 'set_active_delivery_option', payload: undefined });
        }
    };
    const getContent = () => (_jsx(Box, { paddingBlockEnd: "8", children: _jsxs(StackBlock, { gap: "6", children: [_jsx(TextAlpha, { variant: "headingS", children: t('checkout:checkout.delivery.pickuppoint.flyout.title') }), _jsx(PickupPointSearchForm, {}), _jsx(PickupPoints, {})] }) }));
    const getCTAContent = () => (_jsx(ButtonAlpha, { fullWidth: true, theme: "branded", text: t('checkout:checkout.delivery.pickuppoint.flyout.confirm'), state: !highlightedPickupPoint ? 'disabled' : undefined, onClick: selectPickupPoint, testId: "pickuppoint_submit" }));
    return DeliverySheet({
        isOpen,
        onClose: resetDeliveryOption,
        getContent,
        showCTA: !!highlightedPickupPoint,
        getCTAContent,
    });
};
